import type { Label, Type } from '@graphit/types'
import axios from 'axios'

import type { DeepPartial } from 'typeorm'

import env from '../environments'

export async function gets(workspaceId: string) {
	const response = await axios.get(`${env.apiUrl}/settings/workspace/${workspaceId}`)

	return response.data as { labels: Label[]; types: Type[] }
}

export async function getLabel(id: string) {
	const response = await axios.get(`${env.apiUrl}/settings/labels/${id}`)

	return response.data as Label
}

export async function getType(id: string) {
	const response = await axios.get(`${env.apiUrl}/settings/types/${id}`)

	return response.data as Type
}

export async function createLabel(labelData: DeepPartial<Label>) {
	const response = await axios.post<Label>(`${env.apiUrl}/settings/labels/create`, {
		labelData
	})

	return response.data
}

export async function createType(typeData: DeepPartial<Type>) {
	const response = await axios.post(`${env.apiUrl}/settings/types/create`, {
		typeData
	})

	return response.data as Type
}

export async function updateLabel(id: string, labelData: DeepPartial<Label>) {
	const response = await axios.put<Label>(`${env.apiUrl}/settings/labels/${id}`, {
		labelData
	})

	return response.data
}

export async function updateType(id: string, typeData: DeepPartial<Type>) {
	const response = await axios.put(`${env.apiUrl}/settings/types/${id}`, {
		typeData
	})

	return response.data as Type
}

export async function deleteLabel(id: string) {
	await axios.delete(`${env.apiUrl}/settings/labels/${id}`)
}

export async function deleteType(id: string) {
	await axios.delete(`${env.apiUrl}/settings/types/${id}`)
}
